import React from "react";

const Arrowsvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      {" "}
      <path
        d="M3 10.5H7.5M7.5 10.5V15M7.5 10.5L2.25 15.75M15 7.5H10.5M10.5 7.5V3M10.5 7.5L15.75 2.25"
        stroke="black"
        stroke-width="1.56777"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Arrowsvg;

export const SortSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M0 6.87549C0 6.70973 0.0658481 6.55076 0.183058 6.43355C0.300269 6.31634 0.45924 6.25049 0.625 6.25049H6.25C6.41576 6.25049 6.57473 6.31634 6.69194 6.43355C6.80915 6.55076 6.875 6.70973 6.875 6.87549C6.875 7.04125 6.80915 7.20022 6.69194 7.31743C6.57473 7.43464 6.41576 7.50049 6.25 7.50049H0.625C0.45924 7.50049 0.300269 7.43464 0.183058 7.31743C0.0658481 7.20022 0 7.04125 0 6.87549ZM0.625 2.50049H5C5.16576 2.50049 5.32473 2.43464 5.44194 2.31743C5.55915 2.20022 5.625 2.04125 5.625 1.87549C5.625 1.70973 5.55915 1.55076 5.44194 1.43355C5.32473 1.31634 5.16576 1.25049 5 1.25049H0.625C0.45924 1.25049 0.300269 1.31634 0.183058 1.43355C0.0658481 1.55076 0 1.70973 0 1.87549C0 2.04125 0.0658481 2.20022 0.183058 2.31743C0.300269 2.43464 0.45924 2.50049 0.625 2.50049ZM11.25 11.2505H0.625C0.45924 11.2505 0.300269 11.3163 0.183058 11.4335C0.0658481 11.5508 0 11.7097 0 11.8755C0 12.0413 0.0658481 12.2002 0.183058 12.3174C0.300269 12.4346 0.45924 12.5005 0.625 12.5005H11.25C11.4158 12.5005 11.5747 12.4346 11.6919 12.3174C11.8092 12.2002 11.875 12.0413 11.875 11.8755C11.875 11.7097 11.8092 11.5508 11.6919 11.4335C11.5747 11.3163 11.4158 11.2505 11.25 11.2505ZM14.8172 3.3083L11.6922 0.183304C11.6341 0.125194 11.5652 0.0790947 11.4893 0.047642C11.4135 0.0161893 11.3321 0 11.25 0C11.1679 0 11.0865 0.0161893 11.0107 0.047642C10.9348 0.0790947 10.8659 0.125194 10.8078 0.183304L7.68281 3.3083C7.56554 3.42558 7.49965 3.58464 7.49965 3.75049C7.49965 3.91634 7.56554 4.0754 7.68281 4.19268C7.80009 4.30995 7.95915 4.37584 8.125 4.37584C8.29085 4.37584 8.44991 4.30995 8.56719 4.19268L10.625 2.13409V8.12549C10.625 8.29125 10.6908 8.45022 10.8081 8.56743C10.9253 8.68464 11.0842 8.75049 11.25 8.75049C11.4158 8.75049 11.5747 8.68464 11.6919 8.56743C11.8092 8.45022 11.875 8.29125 11.875 8.12549V2.13409L13.9328 4.19268C13.9909 4.25075 14.0598 4.29681 14.1357 4.32824C14.2116 4.35966 14.2929 4.37584 14.375 4.37584C14.4571 4.37584 14.5384 4.35966 14.6143 4.32824C14.6902 4.29681 14.7591 4.25075 14.8172 4.19268C14.8753 4.13461 14.9213 4.06567 14.9527 3.9898C14.9842 3.91393 15.0003 3.83261 15.0003 3.75049C15.0003 3.66837 14.9842 3.58705 14.9527 3.51118C14.9213 3.43531 14.8753 3.36637 14.8172 3.3083Z"
        fill="#595959"
      />
    </svg>
  );
};

export const TickSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 30 30"
      fill="none"
      {...props}
    >
      <path
        d="M14.625 0C11.7325 0 8.90486 0.857741 6.49979 2.46476C4.09472 4.07177 2.2202 6.35589 1.11327 9.02825C0.00633679 11.7006 -0.283287 14.6412 0.281022 17.4782C0.845331 20.3152 2.23823 22.9211 4.28357 24.9664C6.32891 27.0118 8.93484 28.4047 11.7718 28.969C14.6088 29.5333 17.5494 29.2437 20.2218 28.1367C22.8941 27.0298 25.1782 25.1553 26.7852 22.7502C28.3923 20.3451 29.25 17.5176 29.25 14.625C29.2459 10.7475 27.7038 7.02992 24.9619 4.28809C22.2201 1.54625 18.5025 0.00409475 14.625 0ZM21.0459 12.0459L13.1709 19.9209C13.0665 20.0255 12.9424 20.1085 12.8058 20.1651C12.6692 20.2217 12.5228 20.2509 12.375 20.2509C12.2272 20.2509 12.0808 20.2217 11.9442 20.1651C11.8076 20.1085 11.6836 20.0255 11.5791 19.9209L8.20407 16.5459C7.99297 16.3348 7.87438 16.0485 7.87438 15.75C7.87438 15.4515 7.99297 15.1652 8.20407 14.9541C8.41516 14.743 8.70147 14.6244 9.00001 14.6244C9.29854 14.6244 9.58485 14.743 9.79594 14.9541L12.375 17.5345L19.4541 10.4541C19.5586 10.3495 19.6827 10.2666 19.8192 10.2101C19.9558 10.1535 20.1022 10.1244 20.25 10.1244C20.3978 10.1244 20.5442 10.1535 20.6808 10.2101C20.8173 10.2666 20.9414 10.3495 21.0459 10.4541C21.1505 10.5586 21.2334 10.6827 21.2899 10.8192C21.3465 10.9558 21.3756 11.1022 21.3756 11.25C21.3756 11.3978 21.3465 11.5442 21.2899 11.6808C21.2334 11.8173 21.1505 11.9414 21.0459 12.0459Z"
        fill="white"
      />
    </svg>
  );
};
export const SavedAdressSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "40"}
      height={props.height || "40"}
      fill="none"
      {...props}
    >
      <path
        d="M9.5625 10.125C10.8051 10.125 11.8125 9.11764 11.8125 7.875C11.8125 6.63236 10.8051 5.625 9.5625 5.625C8.31986 5.625 7.3125 6.63236 7.3125 7.875C7.3125 9.11764 8.31986 10.125 9.5625 10.125Z"
        stroke="#1454FB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.25 5.0625H3.9375"
        stroke="#1454FB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.25 9H3.9375"
        stroke="#1454FB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.25 12.9375H3.9375"
        stroke="#1454FB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.1875 11.8125C6.58046 11.2885 7.09002 10.8633 7.67582 10.5704C8.26161 10.2775 8.90756 10.125 9.5625 10.125C10.2174 10.125 10.8634 10.2775 11.4492 10.5704C12.035 10.8633 12.5445 11.2885 12.9375 11.8125"
        stroke="#1454FB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1875 15.1875V2.8125C15.1875 2.50184 14.9357 2.25 14.625 2.25L4.5 2.25C4.18934 2.25 3.9375 2.50184 3.9375 2.8125V15.1875C3.9375 15.4982 4.18934 15.75 4.5 15.75H14.625C14.9357 15.75 15.1875 15.4982 15.1875 15.1875Z"
        stroke="#1454FB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
